export default __webpack_public_path__ + "static/media/zalo-black.00cf5dd9.svg";